
import { tagableMixin } from "~/mixins";

const WIDTH = "1024";
const HEIGHT = "767";

export default {
  mixins: [tagableMixin],

  props: {
    images: { type: Array, required: true },
    threeDUrl: { type: String, default: "" },
    sku: { type: String, default: "" },
    tags: { type: Array, default: () => [] },
  },

  data: () => ({ renderStylefit: false }),

  computed: {
    hasMoreImages() {
      return this.images?.length > 1;
    },
  },

  watch: {
    sku(newSku, oldSku) {
      if (newSku !== oldSku) {
        this.renderStylefit = false;
      }
    },
  },

  methods: {
    getImageOptions(image) {
      return {
        src: image.w_1024_h_767,
        webpSrc: image.w_1024_h_767_webp,
        widths: [WIDTH],
        width: WIDTH,
        height: HEIGHT,
      };
    },
  },
};
